<template>
<v-app id="inspire">

    <v-main style="background-color: #24292d;font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
  <v-container fluid fill-height align-start>
    <v-row  >
      <v-col md="12" lg="12" cols="12">
        <h3 class="text-h3 text-center"  style="color: #FFFFFF;font-family: 'Poppins', sans-serif !important;">Premios {{negocio.negocio}}</h3>
        <br/>
        <v-alert
        :value="alertborrador"
        color="red"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Premio se borro con éxito.
       </v-alert>
       <v-alert
        :value="alertnuevo"
        color="primary"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Premio se agrego con éxito.
       </v-alert>
       <v-alert
        :value="alerteditar"
        color="green"
        dark
        dismissible
        border="top"
        transition="scale-transition"
      >
      Su Premio se edito con éxito.
       </v-alert>
        <v-data-table
      :headers="headers"
      :items="Premios"
      sort-by="Premio"
      sort-desc

      class="elevation-1"
      :search="search"
      :loading="progr"
      no-data-text="No hay datos disponibles para mostrar."
      no-results-text="No hay resultados para la búsqueda."
      loading-text="Cargando... Por favor espere."
      style="background-color: #393E46;"
    >
      <template v-slot:top>
        <v-toolbar flat >
          <v-toolbar-title>Premios Ruleta</v-toolbar-title>
         <v-btn @click="damePremios"><v-icon>fas fa-sync-alt</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo Premio</v-btn>
            </template>
            <v-card  color="#393E46">
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-text-field v-model="editedItem.premio" label="Nombre"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-text-field type="number" v-model="editedItem.stock" label="Stock"></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-switch v-model="editedItem.esPremio" label="Es Premio?"></v-switch>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field  v-model="editedItem.color" label="Color Texto" ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-color-picker v-model="editedItem.color" type="hex" hide-inputs  ></v-color-picker>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <v-text-field  v-model="editedItem.fondoColor" label="Color Fondo" ></v-text-field>
                    </v-col>
                    <v-col cols="12" lg="12" sm="12" md="12">
                      <v-color-picker v-model="editedItem.fondoColor" type="hex" hide-inputs  ></v-color-picker>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Grabar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogdelete" persistent max-width="350">
        <v-card  color="#393E46">
          <v-card-title class="headline">Desea eliminar esta Premio?</v-card-title>
          <v-card-text>Estos datos no se volveran a visualizar en el sistema.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="close">No</v-btn>
            <v-btn color="primary darken-1" text @click="borralo">SI</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon
          small
          color="blue"
          class="mr-2"
          @click="editItem(item)"
        >
          fas fa-edit
        </v-icon>
      </template>
          <template v-slot:[`item.dactiva`]="{ item }">
            <v-switch v-model="item.activo" @click="activaItem(item)" ></v-switch>
          </template>
          <template v-slot:[`item.dcolor`]="{ item }">
            <v-chip :color="item.color"  text-color="white" >Texto</v-chip>
          </template>
          <template v-slot:[`item.dcolorfondo`]="{ item }">
            <v-chip :color="item.fondoColor" text-color="white" >Fondo</v-chip>
          </template>
          <template v-slot:[`item.dpremio`]="{ item }">
            <v-switch v-model="item.esPremio" @click="activaItem(item)" ></v-switch>
          </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="damePremios">Cargar de Nuevo</v-btn>
      </template>
    </v-data-table>
      </v-col>
    </v-row>
    <leftmenujuegos :abreviado="abreviado" />
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import axios from 'axios';
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";
import Leftmenujuegos from "@/components/general/leftmenujuegos.vue";

export default {

  title: 'Premios Ruleta | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    Leftmenujuegos,
  },
    data: () => ({
      drawer: null,
      idjuego: 0,
      abreviado:'NN',
      overlay:false,
      negocio: {},
      dbreads: [
      {
        text: 'negocio',
        disabled: true,
        href: 'breadcrumbs_dashboard',
      },
      {
        text: 'Premios',
        disabled: true,
        href: 'breadcrumbs_link_2',
      },
    ],
      progr: true,
      alertborrador: false,
      alertnuevo: false,
      alerteditar: false,
      token:'',
      dialog: false,
      dialogdelete: false,
          date: new Date().toISOString().substr(0, 10),
              menu1: false,

      Premios: [],
      search: '',
      editedIndex: -1,
      editedItem: {
        activo:true,
        color:'#ffffff',
        esPremio:true,
        fondoColor:'#000000',
        icono:'',
        iconoConStock:'',
        iconoSinStock:'',
        id:0,
        juego:{},
        nroPremio:0,
        premio:'',
        stock:0
    },
    defaultItem: {
      activo:true,
      color:'#ffffff',
      esPremio:true,
      fondoColor:'#000000',
      icono:'',
      iconoConStock:'',
      iconoSinStock:'',
      id:0,
      juego:{},
      nroPremio:0,
      premio:'',
      stock:0

    },
headers: [
                { text: 'Acciones', value: 'action', sortable: false },
        { text: 'Premio', align: 'left',  value: 'premio'},
  { text: 'Stock por Dia', align: 'left',  value: 'stock'},
  { text: 'Color Texto', value: 'dcolor' },
  { text: 'Color Fondo', value: 'dcolorfondo' },
      { text: 'Activa', value: 'dactiva' },
  { text: 'Es Premio?', value: 'dpremio' },
      ]
  }),
  mounted (){
        this.idjuego =  this.$route.params.idjuego
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.damePremios();
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.damePremios();
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
    }
  },
   watch: {
    dialog (val) {
      val || this.close()
    },
    "$route.params.idjuego"(value) {
          console.log(value);
           this.idjuego =  this.$route.params.idjuego
           this.negocio = this.negocios.find(x=>x.tag ===this.idjuego)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });
      }else {
        this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.damePremios();
        this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno
      }

    },
  },
  methods : {
    damePremios(){
      this.progr = true;
        axios
        .get('juegos/premios/' + this.idjuego,{
          headers: {
            'Authorization': `Bearer ${this.token}`,
          }
        } )
        .then(response => {
            this.Premios = response.data;
            this.progr = false;
            this.alertborrador = false;
            this.alertnuevo = false;
            this.alerteditar = false;
        })
        .catch((error)  => {
        console.log(error);
          this.progr = false;
        });
    },
    editItem (item) {
      this.editedIndex = this.Premios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    activaItem(item){
      this.editedIndex = this.Premios.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.save()
    },
    deleteItem (item) {
      this.editedIndex = this.Premios.indexOf(item);
      this.dialogdelete = true;
    },

    close () {
      this.dialog = false;
      this.dialogdelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.Premios[this.editedIndex], this.editedItem);
      }else{
        this.editedItem.juego = this.juego
      }

        axios
      .post('juegos/premios/grabar',this.editedItem,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      }).then(response => {
                console.log(response);
                this.alerteditar = true;
          this.Premios = response.data;

          this.editedItem = this.defaultItem
                })
            .catch(error => {
                    this.error = "Hubo un error";
                    console.log(error);
                });

      this.close()
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Premio' : 'Editar Premio'
    },
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    ...mapGetters({
      user: "user",
      juego: "juego",
      usuario: "usuario",
      cliente: "cliente"
    })
  }
};
</script>
